module.exports = __webpack_public_path__ + "static/media/qr.acad18ec.jpg";